import React from "react";
import { Sheet, SheetContent } from "src/components/ui/sheet";
import PanelFileUpload from "./panel-file-upload";
import ManagePanelTable from "./manage-panel-table";
import { Panel } from "../../types/panel.types";
import { Client } from "src/pages/client-management/types/client.types";
import BorderedInput from "src/components/form-new/bordered-input";
import { Lock } from "lucide-react";

interface PanelDrawerProps {
  open: boolean;
  onOpenChange: () => void;
  panel?: Panel;
  activePanel: Panel | null;
  clients: Client[];
  onFileChange: (file: File | null) => void;
  onPanelChange: (field: string, value: any) => void;
  onColumnsChange: (id: string, field: string, value: any) => void;
}

const PanelDrawer: React.FC<PanelDrawerProps> = ({
  open,
  onOpenChange,
  activePanel,
  clients,
  onFileChange,
  onPanelChange,
  onColumnsChange,
}) => {
  if (!open) return null;

  return (
    <Sheet
      open={open}
      onOpenChange={onOpenChange}
    >
      <SheetContent
        side="right"
        className="!w-[75vw] sm:!w-[85vw] !max-w-none overflow-y-auto bg-white"
      >
        {!activePanel && (
          <PanelFileUpload
            onFileChange={onFileChange}
          />
        )}
        {activePanel && (
          <>
            <div className="flex items-center justify-between border-b border-gray-200 pb-2 mb-4">
              <BorderedInput
                className="w-[500px] text-2xl font-light"
                value={activePanel.name}
                onBlur={(e) => onPanelChange('name', e.target.value)}
                disabled={activePanel.locked}
              />
              {activePanel.locked && (
                <Lock className="w-4 h-4" />
              )}
            </div>
            <ManagePanelTable
              panel={activePanel}
              clients={clients}
              onPanelChange={onPanelChange}
              onColumnsChange={onColumnsChange}
            />
          </>
        )}

      </SheetContent>
    </Sheet>
  );
};

export default PanelDrawer;
